var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.252197,
    width: 52.2523,
    height: 52.2523,
    rx: 26.1261,
    fill: "#D4EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3784 16.126H21.3784C18.617 16.126 16.3784 18.3646 16.3784 21.126V31.126C16.3784 33.8874 18.617 36.126 21.3784 36.126H31.3784C34.1398 36.126 36.3784 33.8874 36.3784 31.126V21.126C36.3784 18.3646 34.1398 16.126 31.3784 16.126Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3784 25.4958C30.5018 26.328 30.3596 27.178 29.9721 27.9248C29.5846 28.6716 28.9715 29.2772 28.22 29.6555C27.4685 30.0337 26.6168 30.1654 25.7862 30.0317C24.9555 29.8981 24.1881 29.5059 23.5932 28.911C22.9983 28.316 22.6061 27.5487 22.4724 26.718C22.3388 25.8873 22.4704 25.0357 22.8487 24.2842C23.227 23.5326 23.8326 22.9195 24.5794 22.532C25.3262 22.1445 26.1761 22.0024 27.0084 22.1258C27.8573 22.2517 28.6432 22.6473 29.2501 23.2541C29.8569 23.8609 30.2525 24.6469 30.3784 25.4958Z",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8784 20.626H31.8884",
    stroke: "#0071DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.23ebaef7d9f91ff71169b6f2deab86d9.svg";
export { ForwardRef as ReactComponent };